/** Whether to show available/remaining quota lines in the preflight summary UI. */
export function shouldShowUploadQuotaPreflightLines(preflight: { requiredBytes: number; errorCode?: string }): boolean {
  if (preflight.errorCode === 'FILE_TOO_LARGE') {
    return false;
  }
  return preflight.requiredBytes > 0;
}
